// --- 机构管理 --- //

export default [
  {
    name: 'organizationClassify',
    path: '/platformManagement/organizationManagement/organizationClassify',
    meta: { title: '机构分类' },
    component: require('business/platformManagement/organizationManagement/organizationClassify/list.vue').default
  },
  {
    name: 'organizationList',
    path: '/platformManagement/organizationManagement/organizationList',
    meta: { title: '机构列表' },
    component: require('business/platformManagement/organizationManagement/organizationList/list.vue').default
  }
]
